import script from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=1246c581&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1246c581"]])

export default __exports__